import { useEffect, useState } from "react";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";
import Spacing from "../../../layout/spacing";
import Lottie from "react-lottie";
import { BodyLargeRegular, HeadlineMedium } from "../../../components/font";
import dotLoading from "../../../assets/Dot loading.json";
import loadingAndVerified from "../../../assets/Dot loading and verified.json";

const FlashLoadingScreen = (props: DestinationAccountControllerType) => {
  const { onClickContinue, providerIRAName, setIsLoading, setIsDestinationAnimationLoaded } = props;
  const [animationStep, setAnimationStep] = useState<number>(0);
  useEffect(() => {
    setIsLoading(true);
    setIsDestinationAnimationLoaded(true);
  }, []);

  const finishAccountLoading = () => {
    setAnimationStep(1);
  };

  const finishLoading = () => {
    onClickContinue();
    setIsLoading(false);
  };

  return (
    <TransitionWrapper>
      <ScrollableContainer name="loading">
        <Container>
          <Spacing vertical="30" />
          {animationStep === 0 ? (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: dotLoading,
              }}
              style={{ width: 200, height: 200 }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: finishAccountLoading,
                },
              ]}
            />
          ) : (
            <Lottie
              options={{
                loop: false,
                autoplay: true,
                animationData: loadingAndVerified,
              }}
              style={{ width: 200, height: 200 }}
              eventListeners={[
                {
                  eventName: "complete",
                  callback: finishLoading,
                },
              ]}
            />
          )}
          {animationStep === 0 ? (
            <>
              <HeadlineMedium className="text-center">Just a moment...</HeadlineMedium>
              <Spacing vertical="15" />
              <BodyLargeRegular className="text-center">Verifying your destination account details.</BodyLargeRegular>
            </>
          ) : (
            <HeadlineMedium className="text-center">We’ve connected your {providerIRAName} IRA </HeadlineMedium>
          )}
        </Container>
      </ScrollableContainer>
    </TransitionWrapper>
  );
};

export default FlashLoadingScreen;
